<div class="add-edit-container ter-container nc">
    <fap-section-container [title]="(person ? 'people.editPerson' : 'people.createPerson') | translate">
        <div class="wrp w-100">
            <div class="image mb-3 col-4 p-0">
                <fap-upload-avatar [inputImageUrl]="innerImage" (outputImageLoaded)="imageChanged($event)">
                </fap-upload-avatar>
                <span *ngIf="noProfilePictureError" class="profile-image-error">
                    {{ 'Profile picture required' }}
                </span>
            </div>
            <form [formGroup]="editPersonForm" class="col-md-12 p-0 p-15">
                <div class="form-grid">
                    <div class="form-group">
                        <mat-form-field class="w-100">
                            <mat-label class="col-form-label">{{ 'auth.register.firstName' | translate }}</mat-label>
                            <input matInput formControlName="firstName">
                            <mat-error *ngIf="ifEditPersonFormControlHasError('firstName','required')">
                                <strong>{{ 'auth.validation.requiredField' | translate }}</strong>
                            </mat-error>
                            <mat-error *ngIf="ifEditPersonFormControlHasError('firstName','minlength')">
                                <strong>{{ 'auth.validation.minLengthField' | translate }} 3</strong>
                            </mat-error>
                            <mat-error *ngIf="ifEditPersonFormControlHasError('firstName','maxlength')">
                                <strong>{{ 'auth.validation.maxLengthField' | translate }} 100</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
        
                        <mat-form-field class="w-100">
                            <mat-label class="col-form-label">{{ 'auth.register.lastName' | translate }}</mat-label>
                            <input matInput formControlName="lastName">
                            <mat-error *ngIf="ifEditPersonFormControlHasError('lastName','required')">
                                <strong>{{ 'auth.validation.requiredField' | translate }}</strong>
                            </mat-error>
                            <mat-error *ngIf="ifEditPersonFormControlHasError('lastName','minlength')">
                                <strong>{{ 'auth.validation.minLengthField' | translate }} 3</strong>
                            </mat-error>
                            <mat-error *ngIf="ifEditPersonFormControlHasError('lastName','maxlength')">
                                <strong>{{ 'auth.validation.maxLengthField' | translate }} 100</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group adress-field">
                        <div class="w-100">
                            <mat-label class="col-form-label" [ngClass]="fullAddress ? 'float' : ''">{{ 'user.profile.address' | translate }}</mat-label>
                            <input matInput formControlName="addressId" style="display: none;">
                            <div class="full_address" (click)="editAddress(fullAddress)">
                              {{fullAddress?.number ? fullAddress?.number+',' : ''}} {{fullAddress?.street ? fullAddress?.street+',' : ''}} {{fullAddress?.city ? fullAddress?.city+',' : ''}} {{fullAddress?.postal_code ? fullAddress?.postal_code+'' : ''}} {{fullAddress?.country ? fullAddress?.country : ''}}
                            </div>                          
                          </div>
                    </div>
                    <div class="form-group">
        
                        <mat-form-field class="w-100">
                            <mat-label class="col-form-label">{{ 'people.phone' | translate }}</mat-label>
                            <input matInput formControlName="phone">
                            <mat-error *ngIf="ifEditPersonFormControlHasError('phone','required')">
                                <strong>{{ 'auth.validation.requiredField' | translate }}</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
        
                        <mat-form-field class="w-100">
                            <mat-label class="col-form-label">{{ 'people.job' | translate }}</mat-label>
                            <input matInput formControlName="job">
                            <mat-error *ngIf="ifEditPersonFormControlHasError('job','required')">
                                <strong>{{ 'auth.validation.requiredField' | translate }}</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
                        <fap-add-edit-delete-select
                            inputName="{{ 'party.partyName' | translate }}"
                            class="w-100"
                            [formControl]="editPersonForm.controls['party']"
                            name="party"
                            [inputIsRequired]="true"
                            [apiSearchEnabled]="true"
                            [inputValueFieldName]="'id'"
                            [inputNameFieldName]="'name'"
                            [inputSelectValues]="parties"
                            (click)="getParties()"
                            [inputConfirmDeleteText]="'people.party.deletePartyMessage' | translate"
                            (outputOnDelete)="onDeleteParty($event)"
                            (outputOnCreate)="addPartyModal()"
                            (outputOnScroll)="scrollParties()"
                            (outputOnSearch)="filterParties($event)"
                            (outputOnEdit)="editParty($event)"
                            [addExtraHeight]="status"
                            (selectionChange)="editPersonForm.get('party').setValue($event)"
                            >
                        </fap-add-edit-delete-select>
                    </div>
                    <div class="form-group">
                        <mat-form-field class="w-100">
                            <mat-label>{{ 'people.activeFarms' | translate }}</mat-label>
                            <mat-select formControlName="activeFarms" multiple>
                            <mat-form-field appearance="fill" class="w-100">
                                <input matInput #farmFilter placeholder="Search">
                            </mat-form-field>
                            <div class="scroll_wrap">
                                <mat-option style="height: 0!important;"></mat-option>
                                <mat-option *ngFor="let farm of farms | filter : farmFilter.value" [value]="farm.id">{{ farm.name }}</mat-option>
                            </div>
                            </mat-select>
                          </mat-form-field>
                    </div>
                    <div class="form-group">
                        <fap-add-edit-delete-select
                            [inputName]="'people.groups.groups' | translate"
                            class="w-100"
                            [formControl]="editPersonForm.controls['userGroups']"
                            name="userGroups"
                            [inputIsRequired]="true"
                            [apiSearchEnabled]="true"
                            [inputValueFieldName]="'id'"
                            [inputNameFieldName]="'name'"
                            [inputSelectValues]="groups"
                            [inputConfirmDeleteText]="'people.deleteGroupMessage' | translate"
                            (outputOnDelete)="selectedGroup=$event;deleteGroupModal.showModal()"
                            (outputOnCreate)="addGroupModal()"
                            (outputOnEdit)="editGroup($event)"
                            [multiple]="true"
                            (selectionChange)="editPersonForm.get('userGroups')?.setValue($event); editPersonForm.markAsDirty()"
                            >
                        </fap-add-edit-delete-select>
                    </div>
                </div>
            </form>
        </div>
    </fap-section-container>
    
    <div class="col-12 0 p-0">
        <fap-attributes
        [entityRelation]="'person'"
        [entityId]="entityInfo?.id"
        [entityInfo]="entityInfo"
        [objectId]="personId"
        (formTypeEmit)="formType = $event"
        (formFieldsEmit)="formFields = $event"
    >
    </fap-attributes>
    </div>
</div>
<fap-modal #addEditPartyModal [showFooter]="false"
    inputTitle="{{ 'people.party.addEditParty' | translate }}">
    <fap-add-edit-party [party]="selectedParty"
        (addedParty)="addedParty.emit($event);editPersonForm.controls['party'].setValue($event.id);addEditPartyModal.hideModal()"
        (updatedParty)="updatedParty.emit($event);editPersonForm.controls['party'].setValue($event.id);addEditPartyModal.hideModal()"
        (cancel)="addEditPartyModal.hideModal()">
    </fap-add-edit-party>
</fap-modal>
<fap-modal #deleteUserModal [inputPrimaryButtonInterface]="deleteUserModalButtonPrimaryInterface"
    [inputSecondaryButtonInterface]="deleteUserModalButtonSecondaryInterface"
    inputTitle="{{ 'people.deleteUser' | translate }}">
    {{ 'people.deleteUserMessage' | translate}}
</fap-modal>
<fap-modal #deleteGroupModal [inputPrimaryButtonInterface]="deleteGroupModalButtonPrimaryInterface"
    [inputSecondaryButtonInterface]="deleteGroupModalButtonSecondaryInterface"
    inputTitle="{{ 'people.groups.deleteGroup' | translate }}">
    {{ 'people.groups.deleteGroupMessage' | translate}}
</fap-modal>
<fap-modal #addEditGroupModal [inputTitle]="'people.groups.addEditGroup' | translate">
    <fap-add-edit-group [group]="selectedGroup" (createdGroup)="createdGroup($event)" (cancel)="addEditGroupModal.hideModal()"></fap-add-edit-group>
</fap-modal>
<fap-modal #addEditAddressModal inputTitle="{{ 'party.address.addEditAddressModal' | translate }}" [inputIsLarge]="true">
    <fap-add-edit-address [address]="selectedAddress" [type]="'person'"
        (addedAddress)="addressAdd($event);editPersonForm.controls['addressId'].setValue($event.id);addEditAddressModal.hideModal()"
        (updatedAddress)="addressUpdate($event);editPersonForm.controls['addressId'].setValue($event.id);addEditAddressModal.hideModal()"
        (cancel)="addEditAddressModal.hideModal()"
        >
    </fap-add-edit-address>
</fap-modal>